import React from 'react';
import $ from 'jquery';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
    getRecordReqList, finalcost, assignReqStatus, fedexTrackingApi, checkFaxStatus, downloadRecords,
    faxResendApi, finalCostForView, refreshStatusFalse, adminEditCostDetails, 
} from "../../services/employee/action";
import Model from "../common/model";
import { viewRequestInfo, updateNoteinRequest } from '../../services/common/action'
import { deleteUnprocessedRequest } from '../../services/admin/action';
import DownloadModel from "../patient/downLoadModel";
import Pagination from '../common/pagination';
import moment from "moment";
import { toast } from 'react-toastify';
import {  onlyNumbers, NumbersAndDot} from "../common/keyValidation"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


class RecordReqList extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            recordReqInfoList: [],
            confirmPopUp: false,
            requestId: "",
            facilityName: "",
            mobile: "",
            email: "",
            address: "",
            address2: "",
            city: "",
            faciState: "",
            doctorLastName: "",
            firstName: "",
            lastName: "",
            extraCost: "",
            fedexCost: "",
            finalCost: "",
            pageCost: "",
            pageCount: "",
            serviceCharge: "",
            upchargeCost: "",
            deliveryMode: "",
            file: "",
            changedPageCount: "",
            recordList: [],
            formData: new FormData(),
            facilityId: "",
            editedStatus: false,
            UpdateStatusOne: "",
            employeeStatus: "",
            otherRequestorDocURL: "",
            fedexTrackingNo: "",
            openTrackPop: false,
            faxStatus: "",
            agreeOne: false,
            agreeTwo: false,
            fedexModel_text: "",
            faxStatusReason: "",
            openfaxStatus: false,
            downloadPopup: false,
            resendFaxNo: "",
            src: "",
            pageOfItems: [],
            records: [],
            refreshCost: false,
            userType: "",
            openPopUpDel: false,
            patientName: "",
            createdDate:"",
            thirdPartyRequestId:"",
            dateOfBirth: "",
            phone: "",
            email:"",
            recordAllDate: "",
            recordFromDate: "",
            recordToDate: "",
            openDeletePopUp: false,
            request_id: "",
            administrativeFee: "",
            hedisCost: "",
            pageCountValidation: false,
            errors: {
                faxNoError: "",
                pageCountError: "",
            },
            serviceChargeValid : "",
            pageCostValid : "",
            extraCostValid : "",
            fedexCostValid : "",
            administrativeFeeValid : "",
            hedisCostValid : "",
            faxData: [],
            reqUserType: "",
            fileValid: true,
            searchInput: null,
            baseList: [],
            searchDate:null,
            searchByDateList:[],
            searchByIdList:[],
            openEditCostDetails: false,
            costDetailsToShow :{
                extraCost:"",
                fedexCost:"",
                finalCost:"",
                pageCost:"",
                serviceCharge:"",
                administrativeFee:"",
                hedisCost:"",
                userId : "",
            },
            note:""
        }
        this.noteRef = React.createRef();
    }

    handleEditCost = (e) => {
        const name = e.target.name;
        let value = e.target.value;

        this.setState({ [name]: value },()=>{
           let currencyRegex = /^-?\d*(\.\d{1,2})?$/;
           let nameValid = name + "Valid"

           if (value === "" || !currencyRegex.test(value)) {
              this.setState({
               [nameValid]   : "please enter correct value" 
             })
          }else{
              this.setState({
                [nameValid]   : ""
             }) 
          }

        });
    };

 


    handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        this.setState({ [name]: value });
    };

    componentDidMount() {
        // function to set the height on fly
        function autoHeight() {
            $('.content').css('min-height', 0);
            $('.content').css('min-height', (
                $(document).height() + 32
                - $('.dashHeader').height()
                - $('.footer-section').height()

            ));
            // alert($(document).height() +'-'+ $('.dashHeader').height() +'-'+ $('.footer-section').height());
        }

        // onDocumentReady function bind
        $(document).ready(function () {
            autoHeight();
        });

        // onResize bind of the function
        $(window).resize(function () {
            autoHeight();
        });
        let token = this.props.loginDetails;
        let userType = this.props.profileDetails.commonUser.userType;
        let userId = this.props.profileDetails.commonUser.userId;
        this.setState({
            userType,
            userId
        })

        this.props.getRecordReqList(token, userType, userId );

    }

    onChangePage = (pageOfItems) => {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }



    assignReq = (reqId, status) => {
        let requestId = reqId;
        let token = this.props.loginDetails;
        let employeeId = this.props.profileDetails.commonUser.userId;
        let empStatus = status;


        var formData = new FormData();

        formData.append('requestId', requestId);
        formData.append('employeeId', employeeId);
        formData.append('empStatus', empStatus);


        this.props.assignReqStatus(token, formData, this.state.userType, this.state.userId)
    }

    deleteRequest = () => {
        document.body.classList.remove('modal-open');

        this.setState({
            openPopUpDel: false
        }, () => {
            let reqId = this.state.request_id
            let token = this.props.loginDetails;
            this.props.deleteUnprocessedRequest(token, reqId,  this.state.userType, this.state.userId)
        })
    }

    closePopDel = () => {
        document.body.classList.remove('modal-open');

        this.setState({
            openPopUpDel: false
        })
    }

    pageCountChange = (e) => {
        let pageCount = e.target.value;


        this.setState({
            pageCount: e.target.value,
            refreshCost: true,
            pageCountValidation: false,
            error: {
                pageCountError: "",

            }

        }, () => {

            if (pageCount.length < 1) {
                this.setState({
                    refreshCost: false,
                    pageCountValidation: true,
                    errors: {

                        pageCountError: "Please enter the pagecount",
                    },
                })
            } else {
                this.setState({

                    refreshCost: true,
                    pageCountValidation: false,
                    errors: {
                        pageCountError: "",

                    }
                })

            }
        })




    }
    faxTextDevide = () => {
        let str = this.state.faxStatusModel_text
 



        let faxData = []
        let data = str.split("&")
         if(data.length > 2){
        let zero = data[0].split("=")
        let one = data[1].split("=")
        let two = data[2].split("=")
        let three = data[3].split("=")
        let four = data[4].split("=")
        let five = data[5].split("=")
        let six = data[6].split("=")
        let seven = data[7].split("=")
        let eight = data[8].split("=")
        let nine = data[9].split("=")
        let ten = data[10].split("=")
     faxData = [
            { "property": zero[0], "value": zero[1] },
            { "property": one[0], "value": one[1] },
            { "property": two[0], "value": two[1] },
            { "property": three[0], "value": three[1] },
            { "property": four[0], "value": four[1] },
            { "property": five[0], "value": five[1] },
            { "property": six[0], "value": six[1] },
            { "property": seven[0], "value": seven[1] },
            { "property": eight[0], "value": eight[1] },
            { "property": nine[0], "value": nine[1] },
            { "property": ten[0], "value": ten[1] },]
        }
      
        if(data.length === 2){
            let zero = data[0].split("=")
            let one = data[1].split("=")
            faxData = [
                { "property": zero[0], "value": zero[1] },
                { "property": one[0], "value": one[1] },
                ]
        }
       


        this.setState({
            faxData
        })
    }

    componentWillReceiveProps = nextProps => {

        if (nextProps.getRecordReqStatus) {
            if (nextProps.getRecordReqListData) {
                let ReqInfoList = nextProps.getRecordReqListData.requestInfoList;
                let requestedList = ReqInfoList.filter((record) => {
                    return record.requestStatus === "Requested"
                })

                let paymentPending = ReqInfoList.filter((record) => {
                    return record.requestStatus === "Pending"
                })

                let CompletedList = ReqInfoList.filter((record) => {
                    return record.requestStatus === "Completed"
                })



                let recordReqInfoList = [];

                if (this.props.tab === "Requested") {
                    recordReqInfoList = requestedList
                }
                if (this.props.tab === "Completed") {
                    recordReqInfoList = CompletedList
                }
                if (this.props.tab === "fullList") {
                    recordReqInfoList = ReqInfoList
                }

                if (this.props.tab === "Pending") {
                    recordReqInfoList = paymentPending
                }


                 this.setState({
                    baseList: recordReqInfoList,
                    openfaxStatus: false
                },()=>{
                    this.mergeList()
                })
            }
        }

        if (nextProps.viewRequestInfoStatus) {
            let reqRecordInfo = nextProps.viewRequestInfoDetails.requestInfoDetailes;
        document.body.classList.remove('modal-open');
            this.setState({
                openfaxStatus: false,
                downloadPopup: false,
                openFaxStatusPopUp: false

            })
            this.appendToModelReq(reqRecordInfo);
        }

        if (nextProps.finalCostStatus) {
         document.body.classList.remove('modal-open');
            this.setState({
                editedStatus: true,
                openPopUp: false,
                downloadPopup: false,


            })
        }

        if (nextProps.fedexTrackingStatus) {
            let message = nextProps.fedexTrakingDetails.fedexNotificationDTO ? nextProps.fedexTrakingDetails.fedexNotificationDTO : ""
            document.body.classList.add('modal-open');
            this.setState({
                openTrackPop: true,
                fedexModel_text: message.Message ? message.Message : "No tracking number",
            })
        }

        if (nextProps.checkFaxstatus) {

            let message = nextProps.checkFaxdetails.message ? nextProps.checkFaxdetails.message : ""
            document.body.classList.add('modal-open');
            this.setState({
                openfaxStatus: true,
                faxStatusModel_text: message ? message : "No fax message available",
            }, () => {
                this.faxTextDevide();
            })
        }

        if (nextProps.downloadRecordService) {

            if (nextProps.downloadRecordDetails) {
                let src = nextProps.downloadRecordDetails.url;
                document.body.classList.add('modal-open');
                this.setState({
                    downloadPopup: true,
                    src
                })
            }
        }


        if (nextProps.finalCostForViewStatus) {

            let refreshFinalCost = nextProps.finalCostForViewDetails.finalCostResponseViewDTO
            this.refreshCostbyPages(refreshFinalCost);

        }

        if(nextProps.adminEditCostDetailsStatus){
            let data = nextProps.adminEditCostDetailsData.finalCostResponseViewDTO;
            
            this.adminEditedResponce(data)
        }
    }

    adminEditedResponce = (data) => {
        let extraCost = data.extraCost ? data.extraCost : 0;
        let fedexCost = data.fedexCost ? data.fedexCost : 0;
        let finalCost = data.finalCost ? data.finalCost : 0;
        let pageCost = data.pageCost ? data.pageCost : 0;
        let serviceCharge = data.serviceCharge ? data.serviceCharge : 0;
        let administrativeFee = data.administrativeFee ? data.administrativeFee : 0;
        let hedisCost = data.hedisCost ? data.hedisCost : 0;

         let costDetailsToShow = this.state.costDetailsToShow;
            costDetailsToShow.extraCost = extraCost 
            costDetailsToShow.fedexCost = fedexCost 
            costDetailsToShow.pageCost = pageCost 
            costDetailsToShow.serviceCharge = serviceCharge 
            costDetailsToShow.administrativeFee = administrativeFee 
            costDetailsToShow.hedisCost = hedisCost 

         this.setState({
            extraCost,
            fedexCost,
            finalCost,
            pageCost,
            serviceCharge,
            administrativeFee,
            hedisCost,
            costDetailsToShow

        },()=>{
             this.setState({
                openEditCostDetails :false
            })
        })
    }

    refreshCostbyPages = (data) => {
        let extraCost = data.extraCost ? data.extraCost : 0;
        let fedexCost = data.fedexCost ? data.fedexCost : 0;
        let finalCost = data.finalCost ? data.finalCost : 0;
        let pageCost = data.pageCost ? data.pageCost : 0;
        let serviceCharge = data.serviceCharge ? data.serviceCharge : 0;
        let pageCount = data.pageCount ? data.pageCount : 0;
        let costDetailsToShow = this.state.costDetailsToShow;
            costDetailsToShow.extraCost = extraCost 
            costDetailsToShow.fedexCost = fedexCost 
            costDetailsToShow.pageCost = pageCost 
            costDetailsToShow.serviceCharge = serviceCharge 
         this.setState({
            extraCost,
            fedexCost,
            finalCost,
            pageCost,
            serviceCharge,
            pageCount,
            costDetailsToShow

        })
    }

    appendToModelReq = (req) => {
         let firstName = req.firstName ? req.firstName : "";
        let lastName = req.lastName ? req.lastName : "";

        let recordList = req.records ? req.records : "";


        let extraCost = req.extraCost ? req.extraCost : 0;
        let fedexCost = req.fedexCost ? req.fedexCost : 0;
        let finalCost = req.finalCost ? req.finalCost : 0;
        let deliveryMode = req.deliveryMode ? req.deliveryMode : "";
        let pageCost = req.pageCost ? req.pageCost : 0;
        let pageCount = req.pageCount ? req.pageCount : 0;
        let serviceCharge = req.serviceCharge ? req.serviceCharge : 0;
        let upchargeCost = req.upchargeCost ? req.upchargeCost : 0;
        let otherRequestorDocURL = req.otherRequestorDocURL ? req.otherRequestorDocURL : "";
        let fedexTrackingNo = req.fedexTrackingNo ? req.fedexTrackingNo : 0;
        let faxStatus = req.faxStatus ? req.faxStatus : "";
        let faxStatusReason = req.faxStatusReason ? req.faxStatusReason : "";
        let records = req.records ? req.records : ["no records found"];
        let fName = req.firstName ? req.firstName : "";
        let lName = req.lastName ? req.lastName : "";
        let patientName = fName + " " + lName;
        let createdDate =req.createdDate ? moment(req.createdDate).format('MMM Do YYYY') : "";
        let thirdPartyRequestId = req.thirdPartyRequestId ? req.thirdPartyRequestId : ""
        let date = req.dateOfBirth ? req.dateOfBirth : "";
        let dateOfBirth = moment(date).format("MM-DD-YYYY");
        let phone = req.mobile ? req.mobile : "";
        let email =  req.email ?  req.email : "";
        let administrativeFee = req.administrativeFee ? req.administrativeFee : "0.00"
        let hedisCost = req.hedisCost ? req.hedisCost : "0.00"
        let reqUserType = req.userType ? req.userType : ""

        let recordAllDate = req.recordAllDate ? req.recordAllDate : ""

        let recordFromDate = req.recordFromDate ? req.recordFromDate : ""

        let recordToDate = req.recordToDate ? req.recordToDate : ""
        let note = req.notes ? req.notes : '';
        // finalCost = pageCost + extraCost + fedexCost + serviceCharge + upchargeCost
        let costDetailsToShow = this.state.costDetailsToShow;
        costDetailsToShow.extraCost = extraCost;
        costDetailsToShow.fedexCost = fedexCost;
        costDetailsToShow.pageCost = pageCost;
        costDetailsToShow.serviceCharge = serviceCharge;
        costDetailsToShow.administrativeFee = administrativeFee;
        costDetailsToShow.hedisCost = hedisCost;

 console.log('req  HHHHHHHHHHHHHHHHHHH ', req)

        this.setState({
            createdDate,
            firstName,
            lastName,
            extraCost,
            fedexCost,
            finalCost,
            pageCost,
            pageCount,
            serviceCharge,
            upchargeCost,
            recordList,
            file: recordList,
            otherRequestorDocURL,
            fedexTrackingNo,
            faxStatus,
            faxStatusReason,
            deliveryMode,
            openTrackPop: false,
            records,
            patientName,
            dateOfBirth,
            phone,
            email,
            administrativeFee,
            hedisCost,
            recordAllDate,
            recordFromDate,
            recordToDate,
            reqUserType,
            costDetailsToShow,
            thirdPartyRequestId,
            note
        }, () => {
            document.body.classList.add('modal-open');
            this.setState({
                openPopUp: true
            })
        })
    }

    handleChangeFile = (e) => {
        toast.dismiss()
         var filea = e.target.value;
        var len = filea.length;
        var ext = filea.slice(len - 4, len);
        if (ext.toUpperCase() == ".PDF") {
            this.setState({
                file: e.target.files[0],
                fileValid: false
            })
        }
        else {
        toast.dismiss()
            toast.error("Only PDF files allowed.");
        }
    };

    agreeOne = (e) => {
        this.setState(
            { agreeOne: !this.state.agreeOne }
        );
    };

    agreeTwo = (e) => {
        this.setState(
            { agreeTwo: !this.state.agreeTwo }
        );
    };


    // handleUploadFile = (event) => {
    //     const data = new FormData();
    //     data.append('file', event.target.files[0]);
    //     data.append('name', 'some value user types');
    //     data.append('description', 'some value user types');
    //     // '/files' is your node.js route that triggers our middleware
    //     axios.post('/files', data).then((response) => {
     //     });



    finalCostCalculate = () => {
        toast.dismiss()
        if (this.state.fileValid) {
        toast.dismiss()
            toast.error("Please Upload Records (Only PDF files allowed)")
        } else {
            const { pageCount, requestId, facilityId, file } = this.state
            let employeeId = this.props.profileDetails.commonUser.userId;
            let payload = {
                pageCount,
                requestId,
                facilityId,
                employeeId
            }
            var formData = new FormData();
            formData.append('finalcostDto', JSON.stringify(payload));
            formData.append('multipartFile', file);
            let token = this.props.loginDetails;
            this.props.finalcost(token, formData, this.state.userType, this.state.userId );
        }
    }

    appendToModel = (req) => {
         let facilityName = req.facilityName ? req.facilityName : "";
        let mobile = req.mobile ? req.mobile : "";
        let email = req.email ? req.email : "";
        let faciState = req.state ? req.state : "";
        let address = req.address ? req.address : "";
        let address2 = req.address2 ? req.address2 : "";
        let city = req.city ? req.city : "";
        let doctorLastName = req.doctorLastName ? req.doctorLastName : ""
        let facilityId = req.faciId
        let requestId = req.requestId
        let UpdateStatusOne = req.requestStatus
        let employeeStatus = req.employeeStatus;
console.log("kkkkkkkkkkkkkkkkkkkkkkk", req)

        this.setState({
            facilityName,
            mobile,
            email,
            address,
            address2,
            city,
            faciState,
            doctorLastName,
            facilityId,
            requestId,
            UpdateStatusOne,
            employeeStatus,


        })
    }

    fullView = (e, req) => {
         e.preventDefault();
        let access_token = this.props.loginDetails;
        this.appendToModel(req);
        let payload = {
            requestId: req.requestId
        }
        this.setState({
            agreeOne: false,
            agreeTwo: false,
            resendFaxNo: "",
            errors: {
                faxNoError: ""
            }
        })

        this.props.viewRequestInfo(access_token, payload)
    }

    openTrackPopUp = () => {

        let token = this.props.loginDetails;
        let fedexNo = this.state.fedexTrackingNo;
        let payload = {
            trackingNumber: fedexNo
        }

        this.props.fedexTrackingApi(token, payload);
    }
    closeTrackPop = () => {
    document.body.classList.remove('modal-open');
        this.setState({
            openTrackPop: false
        })
    }
    openFaxStatusPopUp = () => {
        let token = this.props.loginDetails;
        let requestId = this.state.requestId;
        let payload = {
            requestInfoId: requestId,
        }
        this.props.checkFaxStatusApi(token, payload)
    }
    closefaxStatusPopup = () => {
        document.body.classList.remove('modal-open');
        this.setState({
            openfaxStatus: false
        })
    }
    downloadRecord = () => {

        //   this.setState({
        //     downloadPopup: true,
        //   })
        let token = this.props.loginDetails;
        let requestId = this.state.requestId;
        let id = {
            requestId
        }

        this.props.downloadRecords(token, id);


    }

    closeDownload = () => {
        document.body.classList.remove('modal-open');
        this.setState({
            downloadPopup: false
        })
    }

    // resendFaxNoChange= (e)=>{

    //   let faxNo = e.target.value;
    //   this.setState({
    //       resendFaxNo:faxNo,
    //   })
    // }
    resendFax = () => {
        let requestId = this.state.requestId;
        let token = this.props.loginDetails;
        let faxNo = this.state.resendFaxNo;
        let payload = {
            requestInfoId: requestId,
            faxNumber: faxNo
        }
        this.props.faxResendApi(token, payload);
    }

    refreshFinalCost = () => {
        const { pageCount, requestId, facilityId } = this.state
        let employeeId = this.props.profileDetails.commonUser.userId;

        let payload = {
            pageCount,
            requestId,
            facilityId,
            employeeId
        }
        var formData = new FormData();
        formData.append('finalcostDto', JSON.stringify(payload));
        // formData.append('multipartFile', file);
        let token = this.props.loginDetails;
        this.props.finalCostForView(token, formData, this.state.userType, this.state.userId);
    }



    openPopDel = (request_id) => {

        document.body.classList.add('modal-open');

        this.setState({
            openPopUpDel: true,
            request_id
        })

    }
  

    resendFaxNoChange = (e) => {
        e.preventDefault();
        const name = e.target.name;
        const value = e.target.value;

        this.setState({
            resendFaxNo: value

        }, () => {

            if (this.state.resendFaxNo.length != 10) {
                this.setState({
                    errors: {
                        faxNoError: "please enter valid 10 digit fax number"
                    }
                })

            } else {
                this.setState({
                    errors: {
                        faxNoError: ""
                    }
                })
            }
        })
    }
  

    searchInputChange = (e) => {
        toast.dismiss()
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },() => {
                  const { baseList, searchInput} = this.state;
                if (searchInput !== "" && baseList.length > 0 ) {                         
                           let searchByIdList = baseList.filter(item =>{
                                if ((item.requestId.toString()).includes(searchInput) || ( item.thirdPartyRequestId && (item.thirdPartyRequestId.toString()).includes(searchInput))) {
                                        return item
                                    }
                            })

                         if (searchByIdList.length >= 1) {
                            this.setState({
                                searchByIdList:   searchByIdList
                             },()=>{
                            this.mergeList()
                        })  
                        } else {
                            toast.dismiss()
                            toast.error("No Request found with Id number " + searchInput, { autoClose: 2000 })
                            this.setState({
                                searchByIdList: []
                            },()=>{
                            this.mergeList()
                        })  
                        }
                 
                } else {
                    this.setState({
                            searchByIdList: []
                       },()=>{
                this.mergeList()
            })  
                }
             
            });
    }


    filterWithReqId = () => {
        const { baseList, searchInput} = this.state;
         if (searchInput !==""  && baseList.length > 0) {
             let searchByIdList = baseList.filter(item => {
                if (item.requestId == searchInput) {
                    return item
                }
            })

            this.setState({
                searchByIdList: searchByIdList
           },()=>{
                this.mergeList()
            })  
        } else {
            this.setState({
                searchByIdList: []
           },()=>{
                this.mergeList()
            })  
        }
    }

    searchByDate = (date) =>{
          this.setState({
                searchDate: date
            },()=>{
            const { baseList, searchDate, } = this.state;
             if(searchDate !==null && baseList.length > 0){
               let searchByDateList = baseList.filter(item => {
                if (moment(item.createdDate).format('MMM Do YYYY') === moment(searchDate).format('MMM Do YYYY')) {
                    return item
                }
            })
            
              if (searchByDateList.length >= 1) {
                            this.setState({
                                searchByDateList: searchByDateList
                             },()=>{
                                this.mergeList()
                            })  
                        } else {
                            toast.dismiss()
                            toast.error("No Request found with date " + moment(searchDate).format('MMM Do YYYY'), { autoClose: 2000 })
                              this.setState({
                                    searchByDateList: []
                                },()=>{
                                    this.mergeList()
                                })
                        }
            }else{
                 this.setState({
                     searchByDateList: []
                },()=>{
                    this.mergeList()
                })
            }
        })
    }

    mergeList =()=>{
         const { baseList, searchByIdList, searchByDateList} = this.state;
        let recordReqInfoList = [...searchByDateList, ...searchByIdList]
            recordReqInfoList = [...new Map(recordReqInfoList.map(item => [item['requestId'], item])).values()]
         recordReqInfoList = recordReqInfoList.length > 0 ? recordReqInfoList : baseList;
         this.setState({
             recordReqInfoList
         })
    }


    adminEditPaymentCosts = () =>{
        const { administrativeFee,
                hedisCost, 
                extraCost,
                fedexCost,
                pageCost,
                serviceCharge, 
                requestId } = this.state
 
    let payload = {
            requestId,
            extraCost,
            fedexCost,
            pageCost,
            serviceCharge,
            administrativeFee,
            hedisCost,
         }

 
        var formData = new FormData();
        formData.append('adminEditDTO', JSON.stringify(payload));
         let token = this.props.loginDetails;
        this.props.adminEditCostDetails(token, formData, this.state.userType, this.state.userId);
    }

    closeopenPopUp = () =>{
        document.body.classList.remove('modal-open');
        this.setState({ 
            openPopUp: false, refreshCost: false
         }) 
    }

    closeModal = (e) =>{

         this.setState({
            [e.target.name]: false
        })
    }

    closeAdminEditModal = () =>{
        document.body.classList.remove('modal-open');
        let data = this.state.costDetailsToShow;
        let extraCost = data.extraCost;
        let fedexCost = data.fedexCost;
        let pageCost = data.pageCost;
        let serviceCharge = data.serviceCharge;
        let administrativeFee = data.administrativeFee;
        let hedisCost = data.hedisCost;
        this.setState({
            extraCost ,
            fedexCost ,
            pageCost ,
            serviceCharge ,
            administrativeFee ,
            hedisCost ,
            serviceChargeValid:"",
            pageCostValid:"",
            extraCostValid:"",
            fedexCostValid:"",
            administrativeFeeValid:"",
            hedisCostValid:"",
            openEditCostDetails : false
        })
    }

    openModal = (e) =>{
         document.body.classList.add('modal-open');
        this.setState({
            [e.target.name]: true
        })
    }


    // editNote = () =>{
    //     let value = this.state.note
    //       this.setState({
    //         note : ''
    //     },()=>{
    //         this.noteRef.current.focus();
    //     this.setState({
    //         note : value
    //     })
    //     })
    //   }


    handleChangeNote = (e)=>{
        this.setState({
            note : e.target.value
        })
    }

    updateNote = ()=>{
      let token = this.props.loginDetails;
      let payload =  {
            "role": this.state.userType,
            "requestId":this.state.requestId,
            "notes":this.state.note
        }
        this.props.updateNoteinRequest(token, payload)
    }

    render() {

        const {
            serviceChargeValid,
            pageCostValid,
            extraCostValid,
            fedexCostValid,
            administrativeFeeValid,
            hedisCostValid,
            extraCost,
            fedexCost,
            finalCost,
            pageCost,
            pageCount,
            serviceCharge,
            UpdateStatusOne,
            employeeStatus,
            otherRequestorDocURL,
            fedexTrackingNo,
            faxStatus,
            agreeOne,
            agreeTwo,
            faxStatusReason,
            deliveryMode,
            resendFaxNo,
            createdDate,
            thirdPartyRequestId,
            refreshCost,
            userType,
            patientName,
            dateOfBirth,
            phone,
            email,
            openPopUpDel,
            administrativeFee,
            hedisCost,
            errors,
            recordAllDate,
            recordFromDate,
            recordToDate,
            pageCountValidation,
            reqUserType,
            searchInput,
            openEditCostDetails,
            costDetailsToShow,
            searchDate,
            note
        } = this.state
             let adminButtonValid = false
        if(   serviceChargeValid !== "" ||
            pageCostValid !== "" ||
            extraCostValid !== "" ||
            fedexCostValid !== "" ||
            administrativeFeeValid !== "" ||
            hedisCostValid !== "" ){
                  adminButtonValid = true
            }

        return (
            <>

                <div className="content">
                    <div className="contentSection" id="content">
                        <div className="container-fluid">
                            <div className="bodyContent">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">   
                                        <div className="titleBg">
                                            <div class="row mb-2">
                                                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                                                    <h4>{this.props.tab === "Requested" ? "Requested Records" : this.props.tab === "Pending" ? "Pending Records" : this.props.tab === "Completed" ? "Completed Records" : ""} </h4>
                                                </div>
                                                <div class="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                                                    <div className="search-section">
                                                        <input type="text" name="searchInput" value={searchInput} onKeyPress={onlyNumbers} onChange={this.searchInputChange} className="search-input" placeholder="Search with Request Id or Third Party Request Id" />
                                                        <div class="search-icon">
                                                            <button><i class="fa fa-search" onClick={this.filterWithReqId} aria-hidden="true"></i></button>
                                                        </div>
                                                    </div>                                       
                                                </div>
                                                    <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                                                    <div className="form-group r-form customTextCenter">
                                                         <DatePicker selected={searchDate} className="form-control r-txt text-center" id="d"
                                                            type="text" placeholderText="Search with Requested date" name="dat"
                                                            onChange={this.searchByDate} peekNextMonth
                                                            maxDate={new Date()}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            isClearable={true}
                                                            dropdownMode="select" 
                                                            autoComplete="off"/>
                                                        <div className="r-icon">
                                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                                        </div>
                                                    </div>
                                                    </div>
                                                 
                                            </div>
                                        </div>


                                        <div className="table-responsive">
                                            <table className="table commonTable">
                                                <thead>
                                                    <tr>
                                                        <th>Request Id</th>
                                                        <th>Status</th>
                                                        <th>Requested Date</th>
                                                        <th>Third Party Request Id</th>
                                                        {this.props.role === "admin" &&
                                                        <th>Assigned By</th>
                                                        }
                                                        <th>Practice/Doctor</th>
                                                        <th>Location</th>
                                                        <th>Cost</th>
                                                        <th>View</th>
                                                        <th>Assign Status</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.pageOfItems.length > 0 ?
                                                        this.state.pageOfItems.map((req, id) => {
                                                            return (
                                                                <tr key={id} className={req.serviceFeeAvailableOrNot ? "white-background" : "red-background"} >
                                                                    <td>{req.requestId} </td>
                                                                    <td><span className="statusconform" title={req.awaitingPriorApproval === "Pending" ? "Awaiting approval by practice " : req.awaitingPriorApproval === "Denied" ? "Declined" : req.requestStatus === "Requested" ? "Records Requested" : req.requestStatus === "Pending" ? "Payment Pending" : req.requestStatus === "Completed" ? "Payment Completed Records are Ready" : ""} >
                                                                        {req.awaitingPriorApproval === "Pending" ? "AA" : req.awaitingPriorApproval === "Denied" ? "D" : req.requestStatus === "Requested" ? "R" : req.requestStatus === "Pending" ? "P" : req.requestStatus === "Completed" ? "C" : ""}</span></td>
                                                                        <td>{moment(req.createdDate).format('MMM Do YYYY')} </td>
                                                                        <td> {req.thirdPartyRequestId ? req.thirdPartyRequestId : "-"} </td>
                                                                        {this.props.role === "admin" &&
                                                                        <td>{req.employeeName ? req.employeeName : "-"}</td>
                                                            }

                                                                    <td><span>{req.facilityName}</span> <span>Dr. {req.lastName}</span></td>
                                                                    <td>{req.state}</td>
                                                                    <td>{req.finalCost}</td>
                                                                    {this.props.role !== "admin" &&
                                                                        <>
                                                                            <td><button
                                                                                onClick={(e) => this.fullView(e, req)} className="icon view-icon-emp-design" title="View full info"><i className="fa fa-eye" aria-hidden="true"></i></button></td>
                                                                            <td>

                                                                                <button

                                                                                    disabled={req.awaitingPriorApproval === "Pending" ? true : req.awaitingPriorApproval === "Denied" ? true : req.employeeStatus === "Open" ? false : req.employeeStatus === "Assigned" ? true : req.employeeStatus === "Completed" ? true : false}
                                                                                    onClick={() => this.assignReq(req.requestId, "Assigned")} className="action-btn" >
                                                                                    {req.awaitingPriorApproval === "Pending" ? "Awaiting for approval" : req.employeeStatus === "Assigned" ? "Assigned" : req.employeeStatus === "Open" ? "Assign" : req.requestStatus === "Completed" ? "Completed" : ""}
                                                                                </button> </td>
                                                                        </>}
                                                                    {userType === "admin" &&
                                                                        <>
                                                                            <td><button
                                                                                onClick={(e) => this.fullView(e, req)} className="icon view-icon-emp-design" title="View full info"><i className="fa fa-eye" aria-hidden="true"></i></button></td>

                                                                            <td>

                                                                                <button
                                                                                    disabled={req.requestStatus === "Completed" ? true : false}
                                                                                    onClick={() => this.openPopDel(req.requestId)} className="action-btn" >
                                                                                    {req.requestStatus === "Requested" ? "Delete" : req.requestStatus === "Pending" ? "Delete" : req.requestStatus === "Completed" ? "Completed" : ""}
                                                                                </button> </td>
                                                                        </>
                                                                    }

                                                                </tr>
                                                            )
                                                        }) : <tr style={{ background: "transparent" }}><td colspan="6"><img src="images/no-record-found.png" alt="" width="180px" style={{ opacity: "0.6" }} /></td></tr>

                                                    }


                                                </tbody>
                                            </table>
                                        </div>

                                        <Pagination items={this.state.recordReqInfoList} onChangePage={this.onChangePage} />

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {openPopUpDel &&
                    <>
                        <div className="modal fade in " id="editdata" role="dialog">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    {this.props.header &&
                                        <div className="modal-header">
                                            <h4 className="modal-title">Confirm Delete </h4>
                                        </div>
                                    }
                                    <div className="modal-body mod-body">
                                        <h5 className="modal-title mod-title epaperroadmodal" >Are you sure you want to delete</h5>

                                    </div>
                                    <div className="model-btn text-center mb-3">

                                        <button type="button" className="btnDefault" name="openPopUpDel" onClick={this.deleteRequest}  >Ok</button>
                                        <button type="button" className="btnDefault" name="openPopUpDel" onClick={this.closeModal}   >Cancel</button>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </>
                }


                {this.state.openPopUp &&
                    <div className="creatTasks">
                        <div className="modal fade in " id="createtask" role="dialog">
                            <div className="modal-dialog">
                                <div className="modal-content bill-model-design">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Request Summary</h4>
                                        <button type="button" className="close"  onClick={this.closeopenPopUp} >&times;</button>
                                    </div>

                                    <div className="modal-body">

                                        <div className="createtaskbody ">
                                            <div className="bgdefet">
                                                <div className="">
                                                    <div className="settingpage-table">
                                                        <table>
                                                            <tr>
                                                                <td className="heading-table-title">Expedited Fee</td>
                                                                <td>&#36; {costDetailsToShow.serviceCharge} </td>
                                                            </tr>
                                                            <tr>

                                                                <td className="heading-table-title">Page Count</td>
                                                                <td>
                                                                    {(UpdateStatusOne === "Requested" && employeeStatus === "Assigned" && this.props.tab !== "fullList") ? <div><><input type="text" value={pageCount} onChange={this.pageCountChange} maxLength="7" onKeyPress={onlyNumbers} /> <span style={{ color: "red" }}>{errors.pageCountError}</span></></div> : pageCount}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="heading-table-title">Total page Cost</td>
                                                                <td>&#36; {costDetailsToShow.pageCost} </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="heading-table-title">State Base Fee</td>
                                                                <td>&#36; {costDetailsToShow.extraCost} </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="heading-table-title">FedexCost</td>
                                                                <td>&#36; {costDetailsToShow.fedexCost} </td>
                                                            </tr>

                                                            {reqUserType === "other" &&
                                                            <>
                                                            <tr>
                                                                <td className="heading-table-title">Administrative Fee</td>
                                                                <td>&#36; {costDetailsToShow.administrativeFee} </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="heading-table-title">Hedis Cost</td>
                                                                <td>&#36; {costDetailsToShow.hedisCost} </td>
                                                            </tr>
                                                            </>
                                                            }

                                                            <tr>
                                                                <td className="heading-table-title">
                                                                    {(UpdateStatusOne === "Requested" && employeeStatus === "Assigned" && refreshCost) &&
                                                                        <>
                                                                            <button type="button" onClick={this.refreshFinalCost}>Refresh cost details</button>
                                                                        </>
                                                                    }
                                                                    {this.props.tab === "fullList" && UpdateStatusOne !== "Completed" &&
                                                                        <>
                                                                            <button type="button" name="openEditCostDetails" onClick={this.openModal}>Edit cost details</button>
                                                                        </>
                                                                    }
                                                                </td>
                                                                <td><span className="heading-table-title">Total Cost:</span>&#36; {finalCost} </td>
                                                            </tr>
                                                        </table></div>

                                                    <div>

                                                        <label className="fw600 title-model-color mt-2">Requestor Details</label>
                                                        <table className="custom-modal-table-design modal-table-design">
                                                                {reqUserType === 'other' && thirdPartyRequestId !== "" && 
                                                                <tr>
                                                                    <td> <label class="fw600">Third Party Request Id</label></td>
                                                                    <td> <label>{thirdPartyRequestId}</label>  </td>
                                                                </tr>

                                                            }
                                                            <tr>
                                                                <td className="model-td-design"> <label class="fw600">Requestor Name</label></td>
                                                                <td className="model-td-design"> <label>{patientName} </label>  </td>
                                                            </tr>
                                                            {reqUserType !== 'other' &&
                                                                <tr>
                                                                    <td> <label class="fw600">Date of birth</label></td>
                                                                    <td> <label>{dateOfBirth} </label>  </td>
                                                                </tr>

                                                            }                                                   
                                                            <tr>
                                                                <td className="model-td-design">  <label class="fw600">Phone No</label></td>
                                                                <td className="model-td-design"> <label>{phone} </label>  </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="model-td-design">  <label class="fw600">Email ID</label></td>
                                                                <td className="model-td-design"> <label>{email} </label>  </td>
                                                            </tr>
                                                             <tr>
                                                                <td className="model-td-design">  <label class="fw600">Requested date</label></td>
                                                                <td className="model-td-design"> <label> {createdDate}</label> </td>
                                                            </tr>
                                                        </table>
                                                        <label className="fw600 title-model-color mt-2">Requested Delivery Methods</label>
                                                        <table className="modal-table-design">
                                                                 <tr>
                                                                    <td className="model-td-design">  <label class="fw600">Delivery Method</label></td>
                                                                    <td className="model-td-design"> <label>{deliveryMode ? deliveryMode + " , " : ""}Download</label>  </td>
                                                                </tr>
                                                            
                                                        </table>

                                                    </div>
                                                    
                                                   

                                                    <div>
                                                        {(UpdateStatusOne === "Completed" && employeeStatus === "Completed") &&
                                                            <>
                                                              
                                                                        <div className="track-section">
                                                                        {deliveryMode.includes("fedex") &&
                                                                    <>
                                                                            <label for="phone" className="fw600">Fedex Tracking No</label>
                                                                            < input type="text" disabled="true" value={fedexTrackingNo} />
                                                                            <button type="button" title="Track" onClick={this.openTrackPopUp}>Track</button>
                                                                            </>
                                                                }
                                                                            <button onClick={() => this.downloadRecord()} className="icon" title="Download">
                                                                            <i className="fa fa-download" aria-hidden="true"></i></button>
                                                                        </div>

                                                                        
                                                                
                                                                {deliveryMode.includes("efax") &&

                                                                    <div>
                                                                        <div class="status">
                                                                            <label for="phone" class="fw600">FaxStatus</label>
                                                                            <label>{faxStatus} </label>
                                                                            {/* <i class="fa fa-question-circle" aria-hidden="true"></i> */}
                                                                            <span class="track-section">
                                                                                <button type="button" onClick={this.openFaxStatusPopUp}>Check status</button>
                                                                            </span>
                                                                        </div>

                                                                        {faxStatus === "Failed" &&
                                                                            <div>
                                                                                <label for="phone" class="fw600">Fax Number</label>
                                                                                < input type="text" name="faxNo" value={resendFaxNo} maxLength="10" onKeyPress={onlyNumbers} onChange={this.resendFaxNoChange} className="form-control r-txt" />
                                                                                <div style={{ color: "red" }}>{errors.faxNoError}</div>
                                                                                <span class="track-section">
                                                                                    <button type="button" onClick={this.resendFax}>Resend Fax</button>
                                                                                </span>
                                                                            </div>
                                                                        }

                                                                    </div>

                                                                }
                                                            </>
                                                        }
                                                    </div>

                                                    <div>

                                                        <label className="fw600 title-model-color">Requested Records Details</label>
                                                        <ol>
                                                            {this.state.records.map((item, id) => {
                                                                return (

                                                                    <li key={id}>{item.recordName}</li>


                                                                )
                                                            })
                                                            }

                                                        </ol>
                                                    </div>

                                                    <div>

                                                        <label className="fw600 title-model-color"> Medical Records Requested Dates</label>
                                                        <table className="modal-table-design">
                                                            {recordFromDate &&
                                                                <tr>
                                                                    <td className="model-td-design"> <label class="fw600">From Date</label></td>
                                                                    <td className="model-td-design"> <label> {recordFromDate ? recordFromDate : ""} </label>  </td>
                                                                </tr>
                                                            }
                                                            {recordToDate &&
                                                                <tr>
                                                                    <td> <label class="fw600">To Date</label></td>
                                                                    <td> <label> {recordToDate ? recordToDate : ""} </label>  </td>
                                                                </tr>
                                                            }
                                                            {recordAllDate &&
                                                                <tr>
                                                                    <td className="model-td-design">  <label class="fw600">Date</label></td>
                                                                    <td className="model-td-design"> <label>{recordAllDate ? "Requested All Dates" : ""} </label>  </td>
                                                                </tr>
                                                            }
                                                        </table>
                                                        <div className="custom-popup-textarea-section">
                                                            <textarea value={note} ref={this.noteRef}  id="inputNote" className="custom-popup-textarea" placeholder="Add notes :" onChange={this.handleChangeNote}></textarea>
                                                            <div className="custom-popup-textarea-section-btn">
                                                                {/* <button className="view-icon-emp-design" onClick={this.editNote}>Edit</button> */}
                                                                <button className="action-btn" onClick={this.updateNote}>Update</button>
                                                            </div>
                                                            </div>    

                                                    </div>


                                                    {otherRequestorDocURL &&
                                                        <div className="bgdefet1">
                                                            <h4 className="pract1">Document</h4>
                                                            <div  >
                                                                <iframe title="title" src={otherRequestorDocURL} style={{ width: "100%", height: "100vh" }} ></iframe>

                                                            </div>
                                                            <button class="btnDefault"><a href={otherRequestorDocURL} target="_blank" rel="noopener noreferrer" download> Download</a></button>
                                                        </div>
                                                    }

                                                    <div className="form">


                                                        <div>

                                                            {(UpdateStatusOne === "Requested" && employeeStatus === "Assigned" && this.props.tab !== "fullList") &&
                                                                <>
                                                                    <div className="col-lg-12 col-sm-12 col-xs-12 upload-sec-emp" >
                                                                        <h5>Upload Records : </h5>

                                                                        <div className="form-group">
                                                                            <input type="file" name="record" accept=".pdf" onChange={this.handleChangeFile} />
                                                                        </div>

                                                                    </div>


                                                                    <div className="form-group">
                                                                        <div className="rememberme emp-model">

                                                                            <input type="checkbox" id="cbx"
                                                                                onChange={this.agreeOne} className="inp-cbx" checked={this.state.agreeOne}/>
                                                                            <label htmlFor="cbx" className="cbx">
                                                                                I confirm the page count is correct
                                                                </label>

                                                                            {/* <input type="checkbox" id="cbx" onChange={this.agreeOne} className="inp-cbx" style={{ display: "none" }} />
                                                                    <label htmlFor="cbx" className="cbx">
                                                                        <span>
                                                                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                                                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                                                            </svg>
                                                                        </span>
                                                                        <span className="model-check-color"> &nbsp;&nbsp;I confirm the page count is correct</span>

                                                                    </label> */}
                                                                        </div>

                                                                        <div className="rememberme emp-model">
                                                                            <input type="checkbox" id="bx"
                                                                                onChange={this.agreeTwo} className="inp-cbx"  checked={this.state.agreeTwo}/>
                                                                            <label htmlFor="bx" className="cbx">
                                                                                I have completed this request to this specifications entered
                                                                </label>


                                                                            {/* <input type="checkbox" id="bx" onChange={this.agreeTwo} className="inp-cbx" style={{ display: "none" }} />
                                                                    <label htmlFor="bx" className="cbx">
                                                                        <span>
                                                                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                                                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                                                            </svg>
                                                                        </span>
                                                                        <span className="model-check-color"> &nbsp;&nbsp;I have completed this request to this specifications entered</span>

                                                                    </label> */}
                                                                        </div>


                                                                    </div>
                                                                </>
                                                            }

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        <div className="bgdefet">
                                            {(UpdateStatusOne === "Requested" && employeeStatus === "Assigned" && this.props.tab !== "fullList") &&
                                                <div className="modal-footer1">

                                                    <button type="button" disabled={!agreeOne || !agreeTwo || pageCountValidation} onClick={this.finalCostCalculate} className="btngeo clearbtn">Finalize Request</button>

                                                    <button type="button" style={{ float: "right" }} onClick={this.closeopenPopUp} className="btngeo clearbtn">Close</button>

                                                    {/* <button type="button"  onClick={()=>{this.setState({openPopUp:false})}} className="btngeo submitbtn clr448aff" data-dismiss="modal">Submit</button> */}

                                                </div>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {openEditCostDetails &&
                            <div className="creatTasks">
                                <div className="modal fade in " id="createtask" role="dialog">
                                    <div className="modal-dialog">
                                        <div className="modal-content bill-model-design">
                                            <div className="modal-header">
                                                <h4 className="modal-title">Cost Details</h4>
                                                <button type="button" className="close" name="openEditCostDetails" onClick={this.closeAdminEditModal} >&times;</button>
                                            </div>

                                            <div className="modal-body">

                                                <div className="createtaskbody ">
                                                    <div className="bgdefet">
                                                        <div className="">
                                                            <div className="settingpage-table">
                                                                <table>
                                                                    <tr>
                                                                        <td className="heading-table-title">Expedited Fee</td>
                                                                        <td> <input type="text" name="serviceCharge" onKeyPress={NumbersAndDot} value={serviceCharge}  onChange={this.handleEditCost}  /> 
                                                                        <span style={{ color: "red" }}>{serviceChargeValid}</span> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="heading-table-title">Total page Cost</td>
                                                                        <td> <input type="text" name="pageCost" onKeyPress={NumbersAndDot} value={pageCost} onChange={this.handleEditCost}  /> 
                                                                        <span style={{ color: "red" }}>{pageCostValid}</span>  </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="heading-table-title">State Base Fee</td>
                                                                        <td> <input type="text" name="extraCost" onKeyPress={NumbersAndDot} value={extraCost} onChange={this.handleEditCost}  />
                                                                        <span style={{ color: "red" }}>{extraCostValid}</span>   </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="heading-table-title">FedexCost</td>
                                                                        <td> <input type="text" name="fedexCost" onKeyPress={NumbersAndDot} value={fedexCost} onChange={this.handleEditCost}  /> 
                                                                        <span style={{ color: "red" }}>{fedexCostValid}</span>  </td>
                                                                    </tr>
                                                                    {reqUserType === "other" &&
                                                                    <>
                                                                    <tr>
                                                                        <td className="heading-table-title">Administrative Fee</td>
                                                                        <td> <input type="text" name="administrativeFee" onKeyPress={NumbersAndDot} value={administrativeFee} onChange={this.handleEditCost}  /> 
                                                                        <span style={{ color: "red" }}>{administrativeFeeValid}</span>  </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="heading-table-title">Hedis Cost</td>
                                                                        <td> <input type="text" name="hedisCost" onKeyPress={NumbersAndDot} value={hedisCost} onChange={this.handleEditCost}  /> 
                                                                        <span style={{ color: "red" }}>{hedisCostValid}</span>  </td>
                                                                    </tr>
                                                                    </>
                                                                    }
                                                                </table></div>

                                                        </div>
                                                    </div>


                                                </div>
                                                <div className="bgdefet">
                                                 <div className="modal-footer1">

                                                    <button type="button" disabled={adminButtonValid}  onClick={this.adminEditPaymentCosts} className="btngeo clearbtn">Save</button>

                                                    <button type="button" style={{ float: "right" }} name="openEditCostDetails" onClick={this.closeAdminEditModal} className="btngeo clearbtn">Close</button>

 
                                                </div>
                                            
                                        </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        }

                        <Model header="Tracking Status" page="tracking" text={this.state.fedexModel_text} status={this.state.openTrackPop} confirmOkay={this.closeTrackPop} />
                        <Model header="Check Fax Status" page="faxStatus" text={this.state.faxData} status={this.state.openfaxStatus} confirmOkay={this.closefaxStatusPopup} />
                        <DownloadModel status={this.state.downloadPopup} closePop={this.closeDownloadPopup} src={this.state.src} closeDownload={this.closeDownload} />


                    </div>

                }




            </>
        )
    }
}
const mapStateToProps = state => ({
    profileDetails: state.commonReducer.profileDetails,
    loginDetails: state.commonReducer.loginDetails,
    getRecordReqListData: state.employeeReducer.getRecordReqListData,
    getRecordReqStatus: state.employeeReducer.getRecordReqStatus,
    viewRequestInfoStatus: state.commonReducer.viewRequestInfoStatus,
    viewRequestInfoDetails: state.commonReducer.viewRequestInfoDetails,
    finalCostStatus: state.employeeReducer.finalCostStatus,
    fedexTrackingStatus: state.employeeReducer.fedexTrackingStatus,
    fedexTrakingDetails: state.employeeReducer.fedexTrakingDetails,
    checkFaxstatus: state.employeeReducer.checkFaxstatus,
    checkFaxdetails: state.employeeReducer.checkFaxdetails,
    downloadRecordService: state.employeeReducer.downloadRecordService,
    downloadRecordDetails: state.employeeReducer.downloadRecordDetails,
    finalCostForViewStatus: state.employeeReducer.finalCostForViewStatus,
    finalCostForViewDetails: state.employeeReducer.finalCostForViewDetails,
    adminEditCostDetailsData: state.employeeReducer.adminEditCostDetailsData,
    adminEditCostDetailsStatus: state.employeeReducer.adminEditCostDetailsStatus,
});

    

const mapDispatchToProps = dispatch => ({
    getRecordReqList: (token,userType, userId  ) => dispatch(getRecordReqList(token, userType, userId )),
    viewRequestInfo: (token, payload, ) => dispatch(viewRequestInfo(token, payload)),
    finalcost: (token, payload, userType, userId ) => dispatch(finalcost(token, payload, userType, userId)),
    assignReqStatus: (token, formData, userType, userId ) => dispatch(assignReqStatus(token, formData, userType, userId)),
    fedexTrackingApi: (token, payload, ) => dispatch(fedexTrackingApi(token, payload)),
    checkFaxStatusApi: (token, payload) => dispatch(checkFaxStatus(token, payload)),
    downloadRecords: (token, id) => dispatch(downloadRecords(token, id)),
    faxResendApi: (token, payload) => dispatch(faxResendApi(token, payload)),
    finalCostForView: (token, payload,userType, userId, ) => dispatch(finalCostForView(token, payload,userType, userId)),
    deleteUnprocessedRequest: (token, id,  userType, userId ) => dispatch(deleteUnprocessedRequest(token, id, userType, userId)),
    adminEditCostDetails: (token, payload, userType, userId ) => dispatch(adminEditCostDetails(token, payload, userType, userId)),
    refreshStatusFalse: () => dispatch(refreshStatusFalse()),
    updateNoteinRequest : (token, payload) => dispatch(updateNoteinRequest(token, payload)),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(RecordReqList));